import * as icons from './lib';
import { FunctionComponent } from 'react';

export const ICON_MAP = Object.entries(icons).reduce((map, [name, component]) => {
  const svgName = name.replace(/Icon/, '').toLowerCase();

  return { ...map, [svgName]: component };

}, {} as Record<string, FunctionComponent>);

export type IconName = keyof typeof ICON_MAP;
